<template>
	<div>
		<!-- Banner   Start -->
		<div class="wf-banner-wrap">
			<!-- 少图 -->
			<div v-if="localBanner && localBanner.length < 2" class="banner-item">
				<OldVideo
					v-if="localBanner[0] && localBanner[0].type == 'VIDEO' && localBanner[0].url"
					:poster="localBanner[0].image"
					:sourceSrc="localBanner[0].url"
					:isyili="isYili"
				/>
				<img
					v-else
					:src="localBanner[0] ? localBanner[0].image : getIrBaseInfo.backgroundImage"
					width="100%"
					style="height: 2.11rem"
					@click="jumpLink(localBanner[0])"
				/>
				<van-notice-bar
					class="banner-item-title"
					v-if="isYili"
					speed="45"
					:text="localBanner[0] && localBanner[0].title"
				/>
			</div>
			<!-- 多图 -->
			<swiper :options="swiperOption" ref="mySwiper" v-else>
				<swiper-slide v-for="(item, index) in localBanner" :key="index">
					<div class="banner-item">
						<OldVideo
							:ref="`video_${index}`"
							v-if="item.type == 'VIDEO' && item.url"
							:poster="item.image"
							:sourceSrc="item.url"
							:isyili="isYili"
						/>
						<img v-else class="banner" :src="item.image" @click="jumpLink(item)" />
						<!-- 文字滚动 -->
						<van-notice-bar class="banner-item-title" v-if="isYili" speed="45" :text="item.title" />
					</div>
				</swiper-slide>
			</swiper>

			<!-- 页码 -->
			<div class="custom-pagination" v-show="isYili"></div>
			<div
				class="pagination-box"
				ref="paginationbox"
				v-show="localBanner && localBanner.length >= 2"
				v-if="!isYili"
			>
				<div
					class="dot"
					:style="{ 'width': dotwidth + 'px', 'transform': `translate(${translate}px, 0)` }"
				></div>
			</div>
		</div>
		<!-- Banner   End -->
	</div>
</template>
<script>
import OldVideo from '@rebuild/materials/shared/banner/video.vue';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import { NoticeBar } from 'vant';
import { irstore } from '@/fetch/interface';
import { getLanguageType } from '@/assets/js/i18n';
import { mapGetters } from 'vuex';
import { useCommonData } from '@rebuild/hooks/useCommonData';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';

export default {
	components: {
		OldVideo,
		swiper,
		swiperSlide,
		'van-notice-bar': NoticeBar
	},
	props: {},
	data() {
		const that = this;
		return {
			activeIndex: 0,
			dotwidth: 5,
			translate: 0,
			swiperIndex: 0,
			swiperOption: {
				autoplay: false,
				on: {
					transitionEnd: function (swiper) {
						that.translate = that.dotwidth * this.activeIndex;
						let _index = that.swiperIndex;
						let video = that.$refs[`video_${_index}`];
						video && video[0].player.pause();
						that.swiperIndex = this.activeIndex;
					}
				},
				pagination: {
					el: '.custom-pagination',
					type: 'fraction',
					formatFractionCurrent: num => (num < 10 ? '0' + num : num),
					formatFractionTotal: num => (num < 10 ? '0' + num : num)
				}
			},
			localBanner: []
		};
	},
	computed: {
		...mapGetters(['getIrTemplateData', 'getIrBaseInfo'])
	},
	async mounted() {
		this.localBanner = await this.loadData();
		this.$nextTick(() => {
			if (this.$refs.paginationbox && this.$refs.paginationbox.clientWidth) {
				this.dotwidth = this.$refs.paginationbox.clientWidth / this.localBanner.length;
			}
		});
	},
	methods: {
		loadData() {
			return this.$axios
				.get(irstore.getBannerList(this.getIrTemplateData.storeId), {
					languageType: getLanguageType()
				})
				.then(res => {
					// 不存在开启的运营卡片时，取配置的默认背景图
					const publishedBanner = res?.data || [];
					const defaultBackImage = this.getIrBaseInfo.backImage;
					if (defaultBackImage && publishedBanner.length === 0) {
						publishedBanner.push({
							image: defaultBackImage
						});
					}
					return publishedBanner;
				})
				.catch(() => []);
		},
		jumpLink(item) {
			this.viewModule('banner', item);
		}
	},
	setup() {
		const { isYili } = useCommonData();
		const { viewModule } = useModuleNavigation();
		return {
			isYili,
			viewModule
		};
	}
};
</script>
<style lang="less" scoped>
.wf-banner-wrap {
	position: relative;
	.banner-item {
		position: relative;
		&-title {
			position: absolute;
			bottom: 0;
			width: 100%;
			height: 0.27rem;
			background: rgba(0, 0, 0, 0.3);
			padding: 0 0 0 0.14rem;
			font-weight: 400;
			font-size: 0.12rem;
			line-height: 0.27rem;
			color: #ffffff;
		}
	}
	.custom-pagination {
		position: absolute;
		left: 3.2rem;
		bottom: 0.33rem;
		z-index: 33;
		height: 0.16rem;
		width: 0.5rem;
		background: rgba(0, 0, 0, 0.4);
		border-radius: 0.2rem;
		color: #fff;
		line-height: 0.16rem;
		text-align: center;
		font-size: 0.12rem;
	}
}
.banner {
	width: 100%;
	height: 2.11rem;
}
.pagination-box {
	position: absolute;
	left: 50%;
	transform: translate(-50%, 0);
	bottom: 0.2rem;
	width: 0.29rem;
	height: 0.03rem;
	background: rgba(0, 0, 0, 0.6);
	border-radius: 3px;
	z-index: 10;
	.dot {
		width: 0.1rem;
		height: 0.03rem;
		background: #ffffff;
		border-radius: 3px;
	}
}
</style>
